/* global Config */
import {Component} from 'react';

export default class Heartbeat extends Component {
    componentDidMount() {
        this.heartbeat = setInterval(this.checkHeartbeat, 5 * 60 * 1000);
    }

    componentWillUnmount() {
        this.heartbeat = null;
    }

    checkHeartbeat() {
        fetch('/health/heartbeat')
            .then((resp) => resp.json())
            .then((json) => {
                if (
                    json.inMaintenance !== Config.base.inMaintenance ||
                    json.branch !== Config.gitInfo.branch ||
                    json.hash !== Config.gitInfo.hash
                ) {
                  location.reload();
                }
            });
    }

    render() {
        return null;
    }
}
